import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Company } from '../../../core/services/companies/models/company.model';
import { select, Store } from '@ngrx/store';
import { selectCompanies, selectLoadingCompanies, selectSelectedCompany, selectYear } from '../../../core/state/company/company-context.selectors';
import { changeSelectedCompany, changeYear } from '../../../core/state/company/company-context.actions';
import { SelectChangeEvent } from 'primeng/select';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-company-select',
    templateUrl: './company-select.component.html',
    styleUrl: './company-select.component.css',
    standalone: false
})
export class CompanySelectComponent implements OnInit,AfterViewInit, OnDestroy {

  companies: Company[] = [];
  loadingCompanies$ = this.store.pipe(select(selectLoadingCompanies));
  selectedCompany$: Observable<Company | null> = this.store.pipe(select(selectSelectedCompany));
  selectedYear$: Observable<number | null> = this.store.pipe(select(selectYear));

  availableYears = Array.from(
    { length: new Date().getFullYear() - 2020 },
    (_, i) => 2021 + i
  );

  form: FormGroup;

  yearEvent: SelectChangeEvent | undefined;

  private destroy$ = new Subject<void>();

  @ViewChild('resizableBlock') resizableBlock!: ElementRef<HTMLDivElement>;
  private resizeObserver!: ResizeObserver;
  width: number = 0;

  constructor(
    private translate: TranslateService,
    private store: Store
  ) {
    this.form = new FormGroup({
      year: new FormControl(new Date().getFullYear())
    });
  }

  ngOnInit() {
    this.store.pipe(
      select(selectCompanies),
      takeUntil(this.destroy$)
    ).subscribe(companies => {
      this.companies = companies || [];
    });

    this.selectedYear$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(year => {
      if (year !== null) {
        this.form.get('year')?.setValue(year, { emitEvent: false });
      }
    });
  }

  ngAfterViewInit() {
    if (this.resizableBlock?.nativeElement) {
      this.resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          this.width = entry.contentRect.width;
        }
      });

      this.resizeObserver.observe(this.resizableBlock.nativeElement);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.resizeObserver && this.resizableBlock?.nativeElement) {
      this.resizeObserver.unobserve(this.resizableBlock.nativeElement);
      this.resizeObserver.disconnect();
    }
  }

  onChangeCompany(event: Company) {
    const selectedYear = this.form.get('year')?.value; 
    this.store.dispatch(changeSelectedCompany({ item: event }));
    if(this.yearEvent){
      this.onChangeYear(this.yearEvent);
    }
  }

  onConfigureCompanies() {
    //navigate to https://panel.bdomobile.com/companies
    window.open('https://panel.bdomobile.com/companies');
  }

  navigateToManagement() {
    window.open('https://panel.bdomobile.com/dashboard/companies', '_blank');
  }

  onChangeYear(event: SelectChangeEvent) {
    this.yearEvent = event;
    this.store.dispatch(changeYear({ year: event.value }));
  }

}
